import { Col, FormControl, FormGroup, Row } from "react-bootstrap";
import { FiCalendar } from "react-icons/fi";
import { calcAssigmentsStats, formatNumber } from "utils/utils";
import { TbClock, TbClockCheck, TbClockHeart } from "react-icons/tb";
import PlanLineChart from "./PlanLineChart";
import { useState } from "react";
import PlanBarChart from "./PlanBarChart";
import { useTranslation } from "react-i18next";

const ChartsFrame = ({ assigmentsData }) => {
	const { t } = useTranslation();
	const [view, setView] = useState("line");

	let data = {
		targetHours: 0,
		currentHours: 0,
		neededHours: 0,
	};
	if (assigmentsData?.length > 0) {
		data = calcAssigmentsStats(assigmentsData);
	}
	const RenderStaticRow = () => (
		<Row className="header-widgets">
			{[
				{
					label: t('plan.charts.totalTargetHours'),
					value: data.targetHours,
					color: "title-primary",
					icon: TbClock,
				},
				{
					label: t('plan.charts.totalWorkedHours'),
					value: data.currentHours,
					color: "title-green",
					icon: TbClockCheck,
				},
				{
					label: t('plan.charts.staffingNeeds'),
					value: data.neededHours,
					color: "title-yellow",
					icon: TbClockHeart,
				},
			].map(({ label, value, color, icon: Icon }, idx) => (
				<Col sm={12} md={4} key={idx}>
					<article className="widget-content">
						<span className={`widget-title ${color}`}>{label}</span>
						<div className="widget-main">
							<span className="widget-counter">{formatNumber(value)}</span>
							<span className="icon-calendar-wrapper">
								<Icon size={24} />
							</span>
						</div>
					</article>
				</Col>
			))}
		</Row>
	);

	return (
		<div className="plan-charts-frame">
			<RenderStaticRow />
			<Row className="flex-between align-items-center mx-1">
				<h3>{t('plan.charts.hoursEvolution')}</h3>
				<FormGroup className="form-group mb-2" controlId="year">
					<FormControl
						type="text"
						value={view}
						onChange={(e) => setView(e.target.value)}
						as="select"
					>
						<option value="line">{t('plan.charts.viewWeeks')}</option>
						<option value="bar">{t('plan.charts.viewWeekly')}</option>
					</FormControl>
				</FormGroup>
			</Row>
			{view === "line" ? (
				<PlanLineChart assigmentsData={assigmentsData} />
			) : (
				<PlanBarChart assigmentsData={assigmentsData} />
			)}
		</div>
	);
};

export default ChartsFrame;
